// Modules
import { Button, Radio, RadioChangeEvent } from "antd";

// styles
import styles from "components/molecules/Filters/filters.module.css";

// Constants
import { Filters as Constants } from "constants/global";

export type FilterItem = {
	value: string;
	label?: string;
	id: string;
	type?: "search" | "default";
	hasInput?: boolean;
	inputPlaceholder?: string;
	filterName?: string;
};

type FilterProps = {
	filters: Array<{
		title: string;
		values: Array<FilterItem>;
	}>;
	selectedFilers: Array<string | undefined>;
	onClick: ({ value, name, checked, isTextInput }: { name: string; value: string; checked: boolean; isTextInput?: boolean }) => void;
	onReset: () => void;
	onGlobalStateChange?: (filterType: string, value: string) => void;
};

const Filters = ({ filters, selectedFilers, onClick, onReset }: FilterProps) => {
	const handleChange = (e: RadioChangeEvent) => {
		const value = {
			value: e.target.value,
			name: e.target.name || "",
			checked: e.target.checked
		};
		onClick(value);
	};

	return (
		<div className={styles?.root}>
			<div className={styles?.reset_wrapper}>
				<Button className={styles?.reset_button} onClick={onReset}>
					{Constants.RESET_BUTTON_LABEL}
				</Button>
			</div>
			<div className={styles?.filters_wrapper}>
				{filters?.map(({ title, values }, idx) => {
					let selectedValue;
					const len = values.length;
					for (let j = 0; j < len; j++) {
						if (selectedFilers.includes(values[j].value)) {
							selectedValue = values[j].value;
							break;
						}
					}

					return (
						<div key={`${title}-${idx}`}>
							<div className={styles?.filter_header}>{title}</div>
							<div className={styles?.filter_items}>
								<Radio.Group name={title} onChange={handleChange} value={selectedValue}>
									{values?.map((item, index) => {
										return (
											<div className={styles?.filter_item} key={`${item.value}-${index}`}>
												<Radio id={item?.id} value={item.value} className="filter_radio">
													<span className={styles?.item_label}>{item?.label || item?.value}</span>
												</Radio>
											</div>
										);
									})}
								</Radio.Group>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default Filters;
